import styled from 'styled-components'

export const FullHeightWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`

export const FullWidthWrapper = styled.div`
  background-color: #f9f7f6;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const WhiteColumnWrapper = styled.div`
  background-color: white;
  max-width: 980px;
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`

export const ColumnWrapper = styled(WhiteColumnWrapper)`
  background-color: #f9f7f6;
`

export const CenteringWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
`
